import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'emptyValue' })
export class EmptyValuePipe implements PipeTransform {
  transform(value: any, fallback: string = '- -'): any {
    if (typeof value === 'string') {
      const trimmed = value.trim();
      return !trimmed || trimmed.toUpperCase() === 'NULL' ? fallback : trimmed;
    }
    return value == null ? fallback : value;
  }
}